<template>
  <vx-card no-shadow>
    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      id="account-manage-buttons"
    >
      <!-- Img Row -->
      <!-- <div class="flex flex-wrap items-center mb-base">
      <div class="vx-col" id="avatar-col">
        <div class="img-container mb-4">
          <img :src="this.$store.state.user.id_card_photo" class="rounded w-full" />
        </div>
      </div>
      </div>-->
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Name</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required'"
            name="Name"
            class="w-full"
            v-model="name"
          />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{
            errors.first("Name")
          }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span>Email</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input
            v-validate="'required' | 'email'"
            name="Email"
            class="w-full"
            v-model="email"
          />
          <span class="text-danger text-sm" v-show="errors.has('Email')">{{
            errors.first("Email")
          }}</span>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button class="ml-auto mt-2" button="submit">Save Changes</vs-button>
      </div>
    </form>
  </vx-card>
</template>

<script>
import axios from '../../../axios'
import axios120 from '../../../axios120'
export default {
  data() {
    return {
      userAuth: this.$store.state.user,
      name: this.$store.state.user.name,
      email: this.$store.state.user.email,


    }
  },
  mounted() {

  },
  methods: {

    onSubmit() {
      var formData = {

        'id': this.userAuth.id,
        'name': this.name,
        'email': this.email,
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: "#account-manage-buttons",
            scale: 0.45
          })
          axios120.post('ecommerce/web/auth/changeProfile', formData)
            .then(res => {
              if (res.status != 200) {
                this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
                this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
              } else {
                console.log(res)
                this.acceptAlert('success', 'Berhasil', 'Anda berhasil edit profile')
                // router.push('/job')
                this.$store.dispatch('updateUser', res.data)
                this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
              }


            })
            .catch(error => {
              console.log(error.response)
              this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
            })
        } else {
          this.acceptAlert('warning', 'Mohon maaf', 'Data yg anda masukkan belum lengkap, silahkan lengkapi data terlebih dahulu!')
          this.$vs.loading.close("#account-manage-buttons > .con-vs-loading")
        }
      })


    },
    acceptAlert(color, title, message) {

      this.$vs.notify({
        color,
        title,
        text: message
      })

    },

  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  }
}
</script>
